export default __webpack_public_path__ + "static/media/drought-early-warning.fbbe080c.svg";